import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { fetchInitialConfiguration } from '../../Reducers/Configurator/Actions';
import OrderList from "../../Components/OrderList/OrderList";
import { fetchOrders, setConfigurationFromList } from "../../Reducers/Basket/Actions";

const OrderListContainer = (props) => {
  const dispatch = useDispatch();
  const orders = useSelector(state => state.basket.orders);
  return (<OrderList
      {...props}
      orders={orders}
      loadOrders={() => dispatch(fetchOrders())}
      setConfigurationFromList= {(data) => dispatch(setConfigurationFromList(data))}
      loadCode={async (code) => {
        const component = Services.visualization.getComponent();
        if(component){
          Services.store.dispatch({ type: 'RECEIVE_CONFIGURATION', data: { ...Services.store.state.configurator.configuration, item: { ...Services.store.state.configurator.configuration.item, settings: {visualizationCreator: "fallback", visualizationDesigner: "fallback"} }} })
        }
        await Services.configurator.setLoadCode(code);
        await Services.store.dispatch(withGlobalLoader(fetchInitialConfiguration()));
      }}
  />)
}

export default OrderListContainer